import { render, staticRenderFns } from "./ColorCombobox.vue?vue&type=template&id=4668e2d4&scoped=true"
import script from "./ColorCombobox.vue?vue&type=script&lang=js"
export * from "./ColorCombobox.vue?vue&type=script&lang=js"
import style0 from "./ColorCombobox.vue?vue&type=style&index=0&id=4668e2d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4668e2d4",
  null
  
)

export default component.exports